import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from 'react-bootstrap-button-loader';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import TextField from "@material-ui/core/TextField";
import { generateCode, reset } from '../../actions/password';
import * as Redirect from '../../utils/redirect';
import * as StatusCode from '../../scripts/GenericStatusCode';
import * as PasswordStatusCode from '../../scripts/PasswordStatusCode';
import MuiAlert from '@material-ui/lab/Alert';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import * as statusComplexity from '../../scripts/ComplexityPasswordStatusCode'
import { validatePasswordComplexity } from '../../utils/passwordComplexity'
import { format } from 'react-string-format';
import { encryption } from '../../utils/encryption';
import { encryptPassword, getConnectionStringNamePrefix } from '../../utils';
import * as storage from '../../utils/storage';
import styles from '../../styles/password.module.css';
import stylesL from '../../styles/login.module.css';
import { login } from '../../utils/redirect';
import AlertAlgo from '../controls/AlertSnack';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/pro-duotone-svg-icons";


function AlertSnack(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
        backgroundColor: 'var(--color1) !important',
        borderColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    nextButton: {
        backgroundColor: 'var(--color1) !important',
        borderColor: 'var(--color1) !important',
        color: 'var(--color2) !important',
        '&:disabled': {
            backgroundColor: '#bfbfbf !important'
        }
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    button: {
        marginTop: '20px',
        paddingBottom: '20px',
        float: 'right',
    },
    descriptionSteps: {
        margin: '20px'
    },
    formControl: {
        marginTop: '10px'
    },
    buttonLogin: {
        textAlign: 'center',
        marginTop: '20px',
        backgroundColor: 'var(--color1) !important',
        borderColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    divMessageRedirect: {
        textAlign: 'center',
        margin: '50px 25px',
        fontWeight: 'bold'
    }
}));

function getStepContent(stepIndex, isFirstSetup) {
    switch (stepIndex) {
        case 0:
            if (isFirstSetup) {
                return i18next.t('password:description.first-step-first-setup');
            } else {
                return i18next.t('password:description.first-step');
            }
        case 1:
            if (isFirstSetup) {
                return i18next.t('password:description.second-step-first-setup');
            } else {
                return i18next.t('password:description.second-step');
            }
        default:
            return 'Unknown stepIndex';
    }
}

function Password(props) {
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(0);
    const [steps, setSteps] = React.useState([]);
    const [userId, setUserId] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [confirmCode, setConfirmCode] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [resultMessage, setResultMessage] = React.useState('');
    const [openSnack, setOpenSnack] = React.useState(false);
    const [typeMessage, setTypeMessage] = React.useState('success');
    const [keyClient, setKeyClient] = React.useState('');
    const [genericError, setGenericError] = React.useState(`${i18next.t('password:validation.message.generic-error')}`);
    const [isCodeGenerator, setIsCodeGenerator] = React.useState(false);
    const [isSaved, setIsSaved] = React.useState(false);
    const [applyComplexity, setApplyComplexity] = React.useState(false);
    const [minLength, setMinLength] = React.useState(0);
    const [showPassword, setShowPassword] = React.useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = React.useState(false);
    const alertRef = useRef(null);

    const { userCode, isFirstSetup } = props;

    useEffect(() => {
        setSteps([i18next.t('password:step.first-step'), i18next.t('password:step.second-step')]);
        resize();
    }, []);

    useEffect(() => {
        setUserId(userCode);
    }, [userCode]);

    const resize = () => {
        setTimeout(function () {
            const height = window.innerHeight;
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const titleStepper = document.querySelector('#divStepper').clientHeight;

            const customHeight = height - titleBar - titleStepper;

            document.querySelector('#divPassword').style.height = `${customHeight}px`;
            document.querySelector('#divPassword').style.overflowX = 'hidden';
        }, 1000);
    }

    const handleNext = () => {
        // Manage prefix DB
        let connectionName = null;
        const listPrefixConnection = storage.getListPrefixConnection();

        if (listPrefixConnection != null && listPrefixConnection.length > 0) {
            connectionName = getConnectionStringNamePrefix(listPrefixConnection, userId);
        }

        setIsCodeGenerator(true);
        generateCode(userId, email, connectionName).then(result => {
            let message = '';
            if (result.status === StatusCode.SUCCESSFULL) {
                message = i18next.t('password:success.message.confirmation-code')
                setKeyClient(result.key);
                setApplyComplexity(result.applyComplexity);
                setMinLength(result.minLength);
                showMessageSuccess(message);
                setConfirmCode('');
                setPassword('');
                setConfirmPassword('');
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
                setIsCodeGenerator(false);
                return;
            }
            else if (result.status === StatusCode.NOT_VALIDATED) {
                if (result.passwordStatus === PasswordStatusCode.NOT_VALID) {
                    message = i18next.t('password:validation.message.information-invalid')
                } else if (result.passwordStatus === PasswordStatusCode.CODE_ALREADY_EXISTS) {
                    message = i18next.t('password:validation.message.pending-code')
                    showMessageWarning(message);
                    setIsCodeGenerator(false);
                    return;
                } else if (result.passwordStatus === PasswordStatusCode.USER_LOCKED) {
                    message = i18next.t('password:validation.message.user-locked')
                }
                else {
                    // Status code not exists
                    message = i18next.t('password:validation.message.generic-error')
                }
            }
            else {
                // Error
                message = i18next.t('password:validation.message.generic-error')
            }
            showMessageError(message);
            setIsCodeGenerator(false);
        }).catch(error => {
            showMessageError(genericError);
            setIsCodeGenerator(false);
        })
    };

    const validatePassword = () => {
        return new Promise(async (resolve) => {
            let message = '';
            let minPasswordLength = minLength > 0 ? minLength : 3;

            if (password.length === 0 || confirmPassword.length === 0 || confirmCode.length === 0) {
                message = i18next.t('password:validation.message.empty-fields');
            } else if (password !== confirmPassword) {
                message = i18next.t('password:validation.message.confirm-password');
            } else if (password.length < minPasswordLength) {
                message = format(i18next.t('password:validation.message.password-length'), minPasswordLength);
            } else if (applyComplexity) {
                // Complexity
                await validatePasswordComplexity(password).then(status => {
                    if (status === statusComplexity.Error_Number_SpecialCharacter) {
                        message = i18next.t('password:validation.message.number-specialchar');
                    } else if (status === statusComplexity.Error_Two_Letters) {
                        message = i18next.t('password:validation.message.min-two-letters');
                    } else if (status === statusComplexity.Error_Min_Maj_Letters) {
                        message = i18next.t('password:validation.message.min-maj-letters');
                    } else if (status !== statusComplexity.Success) {
                        message = i18next.t('error:generic-error');
                    }
                });
            }

            return resolve(message);
        });
    }

    const handleSave = async () => {
        setIsSaved(true);

        let message = '';

        message = await validatePassword();

        if (message.length > 0) {
            showMessageError(message);
            setIsSaved(false);
        }
        else {
            const passwordEncrypted = encryptPassword(password);
            const passwordAzurEncrypted = encryption(password);

            let intervalTimeout = 2000;

            // Manage prefix DB
            let connectionName = null;
            const listPrefixConnection = storage.getListPrefixConnection();

            if (listPrefixConnection != null && listPrefixConnection.length > 0) {
                connectionName = getConnectionStringNamePrefix(listPrefixConnection, userId);
            }

            reset(userId, email, confirmCode, passwordEncrypted, passwordAzurEncrypted, keyClient, connectionName).then(result => {
                if (result.status === StatusCode.SUCCESSFULL) {
                    setIsSaved(false);

                    if (result.passwordStatus !== PasswordStatusCode.PASSWORD_COMPROMISED_DENIED) {
                        setActiveStep((prevActiveStep) => prevActiveStep + 1);
                        showMessageSuccess(i18next.t('password:success.message.password-saved'));
                    }

                    if (result.passwordStatus === PasswordStatusCode.PASSWORD_COMPROMISED) {
                        intervalTimeout = 7000;
                        setTimeout(() => {
                            showMessageWarning(i18next.t('password:validation.message.password-compromised'));
                        }, 2500);
                    } else if (result.passwordStatus === PasswordStatusCode.PASSWORD_COMPROMISED_DENIED) {
                        showMessageError(i18next.t('password:validation.message.password-compromised-denied'));
                        return;
                    }

                    setTimeout(() => {
                        login();
                    }, intervalTimeout);
                    return;
                }
                else if (result.status === StatusCode.NOT_VALIDATED) {
                    if (result.passwordStatus === PasswordStatusCode.NOT_VALID) {
                        message = i18next.t('password:validation.message.information-invalid')
                    } else if (result.passwordStatus === PasswordStatusCode.EXCEEDED_MAX_ATTEMPS) {
                        message = i18next.t('password:validation.message.exceeded-attempts')
                    } else if (result.passwordStatus === PasswordStatusCode.USER_LOCKED) {
                        message = i18next.t('password:validation.message.user-locked')
                    } else if (result.passwordStatus === PasswordStatusCode.CODE_EXPIRED) {
                        message = i18next.t('password:validation.message.expired-code')
                    } else if (result.passwordStatus === PasswordStatusCode.REUSED_PASSWORD) {
                        message = i18next.t('password:validation.message.reused-password')
                    }
                    else {
                        // Status code not exists
                        message = i18next.t('password:validation.message.generic-error')
                    }
                }
                else {
                    // Error
                    message = i18next.t('password:validation.message.generic-error')
                }
                showMessageError(message);
                setIsSaved(false);
            }).catch(error => {
                showMessageError(genericError);
                setIsSaved(false);
            });
        }
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const onChangeUser = (event) => {
        setUserId(event.target.value.trim());
    }

    const onChangeEmail = (event) => {
        setEmail(event.target.value.trim());
    }

    const onChangeConfirmationCode = (event) => {
        setConfirmCode(event.target.value.trim());
    }

    const onChangePassword = (event) => {
        setPassword(event.target.value.trim());
    }

    const onChangeConfirmPassword = (event) => {
        setConfirmPassword(event.target.value.trim());
    }

    const handleCloseSnack = () => {
        setOpenSnack(false);
    }

    const handleLoginReturn = () => {
        Redirect.login();
    }

    const showMessageSuccess = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showMessageError = (message) => {
        alertRef.current.showMessageError(message);
    }

    const showMessageWarning = (message) => {
        alertRef.current.showMessageWarning(message);
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleClickShowPasswordConfirm = () => {
        setShowPasswordConfirm(!showPasswordConfirm);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <div className={styles.rootPassword}>
            <div className={classes.root}>
                <Stepper id="divStepper" activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <div id="divPassword">
                    {activeStep === steps.length ? (
                        <div className={classes.divMessageRedirect}>
                            {i18next.t('password:success.message.redirectLoginPage')}
                        </div>
                    ) : (
                        <div className={classes.descriptionSteps}>
                            <Typography className={classes.instructions}>{getStepContent(activeStep, isFirstSetup)}</Typography>

                            {activeStep == 0 ?
                                (<div><FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        id="userId"
                                        label={i18next.t('password:form.userId')}
                                        value={userId}
                                        onChange={onChangeUser}
                                        disabled={isFirstSetup}
                                    />
                                </FormControl>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            id="email"
                                            label={i18next.t('password:form.email')}
                                            value={email}
                                            onChange={onChangeEmail}
                                        />
                                    </FormControl></div>)
                                :
                                (<div>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            id="confirmationCode"
                                            label={i18next.t('password:form.confirmationCode')}
                                            value={confirmCode}
                                            onChange={onChangeConfirmationCode}
                                        />
                                    </FormControl>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            id="password"
                                            label={i18next.t('password:form.newPassword')}
                                            type={showPassword ? 'text' : 'password'}
                                            value={password}
                                            onChange={onChangePassword}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}
                                                            className={stylesL.eyeIcon}
                                                        >
                                                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} className={stylesL.icon_passwordVisibility} />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <TextField
                                            id="confirmPassword"
                                            label={i18next.t('password:form.confirmationPassword')}
                                            type={showPasswordConfirm ? 'text' : 'password'}
                                            value={confirmPassword}
                                            onChange={onChangeConfirmPassword}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPasswordConfirm}
                                                            onMouseDown={handleMouseDownPassword}
                                                            className={stylesL.eyeIcon}
                                                        >
                                                            <FontAwesomeIcon icon={showPasswordConfirm ? faEye : faEyeSlash} className={stylesL.icon_passwordVisibility} />
                                                        </IconButton>
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </FormControl>
                                </div>)
                            }

                            <div className={classes.button}>
                                {activeStep === steps.length - 1 ?
                                    <Button onClick={handleSave} loading={isSaved} variant="success" className={classes.nextButton}>
                                        {i18next.t('password:button.save')}
                                    </Button>
                                    :
                                    <Button onClick={handleNext} loading={isCodeGenerator} variant="success" className={classes.nextButton}>
                                        {i18next.t('password:button.next')}
                                    </Button>
                                }
                            </div>
                        </div>
                    )}
                </div>
                <AlertAlgo ref={alertRef} />
            </div>
        </div>
    );
}

export default withNamespaces(['password', 'error'], { wait: true })(Password);